import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getInstitutions, getInstitutionPreference } from '../../../Institution/InstitutionActions';
import { getCurrentApplicant } from '../../../Applicant/ApplicantActions';
import { getSessionOption } from '../../../Session/SessionActions';
import { getLoggedUser } from '../../../User/UserActions';

class SupportChat extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isMounted: false,
            isDepartmentSpecified: false,
            userId: '',
        };
    }

    componentDidMount() {
        if(this.wrapper && process.env.NODE_ENV === 'production') {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.innerHTML = 'window.$zopim||(function(d,s){var z=$zopim=function(c){z._.push(c)},$=z.s=d.createElement(s),e=d.getElementsByTagName(s)[0];z.set=function(o){z.set._.push(o)};z._=[];z.set._=[];$.async=!0;$.setAttribute("charset","utf-8");$.src="https://v2.zopim.com/?3yV68MOqYDFKQ12zwjpxsLsW6Tjedinu";z.t=+new Date;$.type="text/javascript";e.parentNode.insertBefore($,e)})(document,"script");';
            this.wrapper.appendChild(script);

            setTimeout(() => {
                this.setMounted();
            }, 1000);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.isMounted
            && (
                !this.state.isDepartmentSpecified
                || (this.props.user && prevState.userId !== this.props.user._id)
                || (this.props.currentApplicant && (!prevProps.currentApplicant || this.props.currentApplicant._id !== prevProps.currentApplicant._id))
            )
            && (this.props.institutions || this.props.user)
        ) {
            this.getSpecifiedDepartment();
        }
    }

    setMounted() {
        this.setState({
            isMounted: true,
        });
    }

    getSpecifiedDepartment() {
        if(window.$zopim && window.$zopim.livechat && this.wrapper) {
            let additionnalScript = '';
            if(this.props.user) {
                this.setState({
                    userId: this.props.user._id,
                });
                additionnalScript += `$zopim.livechat.setName("${this.props.user.firstName} ${this.props.user.lastName}"); $zopim.livechat.setEmail("${this.props.user.email}");`;
            }

            let department = '';
            if(this.props.currentApplicant) {
                department = getSessionOption(this.props.currentApplicant.session, 'supportLiveChat');
            }
            if(!department) {
                if(this.props.institutions && this.props.institutions.length) {
                    const institution = this.props.institutions.find(institution => getInstitutionPreference(institution, 'supportLiveChat'));
                    if(institution) {
                        department = getInstitutionPreference(institution, 'supportLiveChat');
                    }
                }
            }
            // if(!department) {
            //     department = 'Managexam';
            // }
            if(department) {
                additionnalScript += `$zopim.livechat.departments.setVisitorDepartment("${department}");`;
            }

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.innerHTML = additionnalScript;
            this.wrapper.appendChild(script);

            if(additionnalScript) {
                this.setState({
                    isDepartmentSpecified: true,
                });
            }
        } else {
            setTimeout(() => this.getSpecifiedDepartment(), 1000);
        }
    }

    render() {
        return <div ref={el => (this.wrapper = el)} />;
    }
}

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
        institutions: getInstitutions(store),
        currentApplicant: getCurrentApplicant(store),
    };
}

SupportChat.propTypes = {
    user: PropTypes.object,
    institutions: PropTypes.arrayOf(PropTypes.object),
    currentApplicant: PropTypes.object,
};

export default connect(mapStateToProps)(SupportChat);
